import React, { createContext, useState } from "react";

export const SearchStaffContext = createContext({});

const SearchStaffProvider = ({ children }) => {
  const [searchValues, setSearchValues] = useState({
    prefix: "",
    staffName: "",
    staffLastname: "",
    fullName: "",
    positionUniqueId: "",
  });
  const [pageValues, setPageValues] = useState({
    page: 0,
    pageSize: 10,
    sortBy: "createDate",
    sortDirection: "DESC",
  });
  const [search, setSearch] = useState(true);

  return (
    <SearchStaffContext.Provider
      value={{
        searchValues,
        setSearchValues,
        pageValues,
        setPageValues,
        search,
        setSearch,
      }}
    >
      {children}
    </SearchStaffContext.Provider>
  );
};

export default SearchStaffProvider;
